import React from 'react'
import {Page} from './'

export default () => (
    <Page title="Legal Info">
        <p>
            User is made aware and acknowledges that the materials (data, pictures, trademarks, slogans and more broadly
            information and documents posted on “Le BrandCenter” website) are covered by intellectual property rights
            and shall remain the sole property of RICHARD MILLE Group – HOROMETRIE S.A. RICHARD MILLE – HOROMETRIE S.A.
            owns and shall continue to retain the rights, title and interest in its own intellectual property including,
            without limitation as contained in patent applications, inventions, discovery, process, art, method,
            know-how, trade secrets, product trademarks, service trademarks, commercial brand names, design, copyright
            and other intellectual property rights, whether or not patentable, existing in relation with the
            information, pictures, materials, documents, products and inventions displayed on “Le BrandCenter” website.
        </p>
        <p>
            User agrees that he will use such information only to the extend necessary for the purpose of which he
            accessed to the “Le BrandCenter” website and that no right of any kind nor license of any kind is either
            granted or implied by the access to such information, material and other documents posted on “Le
            BrandCenter” website.
        </p>
        <p>
            Consequently, user shall prevent himself from copying or having copied any of such information, nor to
            disclose or spread it to the public.
        </p>
        <p>
            No permission is granted to print, copy, reproduce, distribute, transmit, upload, download, store, perform,
            display in public, alter, or modify the content contained on or in this website.
        </p>
        <p>
            ALL BRAND NAMES, TRADEMARKS AND PERSONAL NAMES ARE PROPERTY OF THEIR RESPECTIVE OWNERS WHICH IS EXPRESSLY
            RESERVED AND PROTECTED.
        </p>
    </Page>
)


// WEBPACK FOOTER //
// ./src/scenes/Pages/container/Legals.js